// extracted by mini-css-extract-plugin
export default {"left-container":"HeaderLeft_left-container__w190z","logo":"HeaderLeft_logo__P+q7l"};